import React, { useContext } from 'react'
// import { Link } from 'gatsby'
import LayoutContext from './LayoutContext'
import TransitionLink from 'gatsby-plugin-transition-link'

function LocalLink({ children, to, ...props }) {
    const { currentLang } = useContext(LayoutContext)
    const path = to === `/` ? `${currentLang.prefix}` : `${currentLang.prefix}${to}`

    return (
        <TransitionLink
            {...props}
            to={path}
            exit={{
                length: 0.5,
            }}
            entry={{ delay: 0.5 }}
        >
            {children}
        </TransitionLink>
    )
}

export default LocalLink
